import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { alertaGeneral } from "../../utils/alertas";
import apiClient from "../../utils/axiosPetition";

const PagRespuestaPassToMember = () => {
    const [searchParams] = useSearchParams();
    const params = useParams();
    const service = params?.service;
    const [transactionState] = searchParams.get('transactionState') || '';
    const [isApproved, setIsApproved] = useState(false);
    const navigate = useNavigate();

    if (!transactionState || !service) {
        //Por chistoso
        localStorage.clear();
        navigate('/login');
    }

    const onApproved = () => {
        apiClient.post('/api/afiliado/quiero-ser-miembro', { service })
            .then(res => {
                if (res.status === 201) {
                    localStorage.clear();
                    alertaGeneral({
                        titulo: "Bienvenido a Redplika",
                        messageHtml: "Inicia sesión nuevamente para disfrutar de los beneficios de ser miembro",
                    }).then(result => {
                        navigate('/');
                    });
                }
            }).catch(error => {
                alertaGeneral({
                    titulo: "Error",
                    messageHtml: "Ha ocurrido un error en el servidor",
                    isError: true
                });
            })
    }

    useEffect(() => {
        if (transactionState === "4" && !isApproved) {
            alertaGeneral({
                titulo: "Transacción Aprobada",
            }).then(result => {
                onApproved();
                setIsApproved(true);
            });
        } else if (transactionState !== "4") {
            alertaGeneral({
                titulo: "Error",
                messageHtml: "La transacción no fue aprobada",
                isError: true,
            });
        }
    }, [transactionState, isApproved]);

    return null;
}

export default PagRespuestaPassToMember;